import { gql } from "@apollo/client";

export const GET_SUGGESTED_SAVES = gql`
  query SuggestedSaves($limit: Int!) {
    me {
      suggestedSaves(limit: $limit) {
        id
        internalId
        title
        status
        type
        createdAt
        views
        shareId
        thumbnailUrl(style: STANDARD)
        saved {
          savedBy
          savedAt
        }
      }
    }
  }
`;

export const CLIP_STORAGE_STATUS = gql`
  query MyClipStorage {
    me {
      clipStorageStatus {
        success
        savedCount
        limit
      }
    }
  }
`;
